import _jsx from "@babel/runtime/helpers/jsx";
var _Icon;
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
var css = {
  "search": "rui-owJ3W",
  "option": "rui-RFqlr",
  "recentSearchItem": "rui-sRHR6",
  "suggestion": "rui-kudsJ",
  "suggestionCategory": "rui-1r1SF",
  "currentSearch": "rui-ToQNb",
  "icon": "rui-4Gsnj",
  "autosOption": "rui-BaHnN",
  "recentSearchHeading": "rui-ZStik",
  "lowercase": "rui-xbpMn",
  "header": "rui-cF4qg",
  "visible": "rui-eCpOG"
};
import Icon from '../Icon/Icon';
export var RecentSearches = function RecentSearches(_ref) {
  var key = _ref.key,
    index = _ref.index,
    value = _ref.value,
    onSelect = _ref.onSelect,
    isSelected = _ref.isSelected,
    recentSearchTitle = _ref.recentSearchTitle,
    recentSearchIcon = _ref.recentSearchIcon,
    onRemove = _ref.onRemove,
    _onMouseOver = _ref.onMouseOver;
  var formatTitle = function formatTitle() {
    var _recentSearchTitle$to;
    if (!value || typeof value !== 'string') {
      return recentSearchTitle;
    }
    return /*#__PURE__*/_jsx("span", {
      className: css.suggestion
    }, void 0, recentSearchTitle === null || recentSearchTitle === void 0 ? void 0 : (_recentSearchTitle$to = recentSearchTitle.toLowerCase()) === null || _recentSearchTitle$to === void 0 ? void 0 : _recentSearchTitle$to.split(value.toLowerCase()).reduce(function (prev, current, i) {
      if (!i) {
        return [current];
      }
      var alteredValue = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      return prev.concat( /*#__PURE__*/_jsx("span", {
        className: css.currentSearch
      }, value + current, alteredValue), current === null || current === void 0 ? void 0 : current.toLowerCase());
    }, []));
  };
  var formattedTitle = formatTitle();
  return /*#__PURE__*/_jsx("li", {
    role: "option",
    className: css.recentSearchItem,
    "aria-selected": isSelected,
    onMouseOver: function onMouseOver() {
      return _onMouseOver(index);
    },
    onClick: function onClick() {
      return onSelect(recentSearchTitle, index);
    },
    onFocus: function onFocus() {},
    "data-aut-id": "recentSearchItem"
  }, key, /*#__PURE__*/_jsx("div", {}, void 0, recentSearchIcon, formattedTitle), /*#__PURE__*/_jsx("button", {
    onClick: function onClick(event) {
      return onRemove(event, recentSearchTitle);
    }
  }, void 0, _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
    icon: "cross",
    size: 10.15
  }))));
};
RecentSearches.propTypes = {
  key: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  recentSearchTitle: PropTypes.string.isRequired,
  onMouseOver: PropTypes.func,
  isSelected: PropTypes.bool,
  icon: PropTypes.string,
  index: PropTypes.number.isRequired,
  onRemove: PropTypes.func.isRequired,
  value: PropTypes.string,
  recentSearchIcon: PropTypes.node
};
RecentSearches.defaultProps = {
  icons: '',
  value: ''
};
export default RecentSearches;